// import { useState, useEffect, useRef } from "react";
// import io from "socket.io-client";
// import {
//   SocketTopics,
//   PageTopics,
//   MapTopics,
//   MessageTopics,
//   TwilioTopics,
//   CLBSTopics,
//   UserSearchTopics,
// } from "../constants/enums";
// import useSocketActions from "./socketActions";
// import {  useSelector } from "react-redux";
// import { RootState } from "reducers/rootReducer";

// export default () => {
//   const [socketClient, setSocketClient] = useState<SocketIOClient.Socket>();
//   const { requestIds } = useSelector((state: RootState) => state.dashboard);

//   const {
//     handlePageResults,
//     handleFocusMap,
//     handleTextMessage,
//     handlePageTyping,
//     handleVideoJoinNotification,
//     handleVideoEndedNotification,
//     handleSaveVideoNotification,
//     handleRecordingMediaResult,
//     handleUser,
//     handleSearchMessageResult,
//     handleGetPlaces,
//     handleGetTokenResult,
//     handleConnectionResult,
//     handleSearchInPageResult,
//     handleIotAppend,
//     handleCreatePageResult,
//     handleMessageFocus,
//     handleFindUsersToPage,
//     handleSearchBds,
//     handleUserBds,
//     handleUpdatePageResult,
//     handleVideoIotAppend,
//     getProjectList,
//     getAdminRolesList,
//     handleGetLastIndex,
//     handlePageFocus
//   } = useSocketActions();

//   const subscriptions = useRef([])
//   const isConnected = useRef(false)

//   const socketConnect = () => {
//     setSocketClient(
//       io.connect(process.env.REACT_APP_API_URI, {
//         transports: ["websocket"],
//       })
//     );
//   };

//   useEffect(() => {
//     return () => {
//       if (socketClient) {
//         socketClient.disconnect();
//       }
//     };
//   }, []);

//   useEffect(() => {
//     if (socketClient) {
//       socketClient.on("connect", () => {
//         if(!isConnected.current){
//           isConnected.current = true;
//         }
//         else{
//           setTimeout(()=>{
//             subscriptions.current.map((topic)=>{
//               subscribeToEvent(SocketTopics.SubscribePageTopics, topic, ()=>{})
//             })
//           }, 1000)
//         }

//       });
//       socketClient.on("error", (err) => {
//         console.error("Connection error: ", err);
//         socketClient.disconnect();
//       });
//       socketClient.on("reconnect", () => {

//         console.log("Reconnecting...");
//       });
//       socketClient.on("disconnect", () => {
//         console.log("Disconnecting...");
//       });
//       socketClient.on("message", (data) => {
//         console.log("on message", data);
//       });
//     }
//   }, [socketClient]);

//   const publishToEvent = (
//     event: SocketTopics,
//     topic: string,
//     data: IPublishWrapRequest | IPublishRequest,
//     callback: any = () => {}
//   ) => {
//     if (socketClient) {
//       socketClient.emit(event, { payload: { ...data }, topic }, callback);
//     }
//   };

//   const subscribeToEvent = (
//     event: SocketTopics,
//     topic: string,
//     callback: any = () => {}
//   ) => {
//     socketClient.emit(event, { topic });
//     socketClient.off(topic).on(topic, (data: any) => {
//       // console.log('subscriber listner', data, topic);

//       if (data?.status !== undefined) {
//         if (!data.status)
//           console.log(`Subscribe to ${topic} error`, data.message);
//         callback(data);
//       } else {
//         socketMessageReceivedListener(topic, data);
//       }
//     });
//     if(subscriptions.current.indexOf(topic) === -1){
//       subscriptions.current.push(topic)
//     }
//     // console.log('subscriptions list here', subscriptions.current);
//   };

//   const unSubscribeToEvent = (
//     event: SocketTopics,
//     topic: string,
//     callback: any = () => {}
//   ) => {
//     socketClient.emit(event, { topic });
//     socketClient.off(topic);
//     const topicIndex = subscriptions.current.indexOf(topic);
//     if(topicIndex !== -1){
//       subscriptions.current.splice(topicIndex, 1)
//     }
//     // console.log('subscriptions list here', subscriptions.current);
//   };

//   const publishToEventUser = (event: SocketTopics, topic: string, data: IPublishRequest, subscribePath: string, callback: any= ()=>{})=>{
//     if(socketClient){
//       socketClient.emit(event, {payload: {...data}, topic,subscribePath }, callback);
//     }
//   };

//   const publishToEventServiceIdUser = (event: SocketTopics, topic: string, data: IPublishRequest, subscribePath: string, serviceId: string, callback: any= ()=>{})=>{
//     if(socketClient){
//       socketClient.emit(event, {payload: {...data}, topic,subscribePath, serviceId }, callback);
//     }
//   };

//   const subscribeToEventUser = (event: SocketTopics, topic: string, callback: any= ()=>{})=>{
//     socketClient.emit(event, { topic})
//     socketClient.off(topic).on(topic, (data: any)=>{

//       if(data?.status !== undefined)
//         {
//             if(!data.status)
//                 console.log(`Subscribe to ${topic} error`, data.message);
//             callback(data);
//             socketMessageReceivedListener(topic, data)
//         }
//     })
//   }

//   const socketMessageReceivedListener = (topic: string, message: any) => {
//     const payload = { topic, message: JSON.stringify(message) };
//     // console.log('payload here', payload);

//     if (topic.includes(PageTopics.SearchPageResult)) {

//       const requestId = localStorage.getItem("pageRequestId");
//       console.log('test page3 id', JSON.parse(payload.message)?.id)
//       if (requestId !== JSON.parse(payload.message)?.id) {
//         return;
//       }

//       handlePageResults(JSON.parse(payload.message).response.data);
//     } else if (topic.includes(MapTopics.FocusMap)) {
//       handleFocusMap(message);
//     } else if (topic.includes(MapTopics.IotAppend)) {
//       handleIotAppend(payload);
//     } else if (topic.includes(MessageTopics.CreateMessageResult)) {
//       handleTextMessage({ subscribeToEvent, publishToEvent }, payload);
//     } else if (topic.includes(PageTopics.PageTyping)) {
//       handlePageTyping(payload);
//     } else if (topic.includes(TwilioTopics.VideoJoin)) {
//       handleVideoJoinNotification(JSON.parse(payload.message).data);
//     } else if (topic.includes(TwilioTopics.VideoEnd)) {
//       handleVideoEndedNotification(JSON.parse(payload.message).data);
//     } else if (topic.includes(TwilioTopics.SaveRecording)) {
//       handleSaveVideoNotification(JSON.parse(payload.message).data);
//     } else if (topic.includes(TwilioTopics.RecordingMediaResult)) {
//       handleRecordingMediaResult(payload);
//     } else if (topic.includes("user")) {
//       handleUser({ subscribeToEvent, publishToEvent }, topic, payload);

//     } else if (topic.includes(MessageTopics.SearchMessageResult)) {
//       console.log("handle message", JSON.parse(payload.message));
//       handleSearchMessageResult(payload);
//     } else if (topic.includes(CLBSTopics.GetPlaces)) {
//       handleGetPlaces(payload);
//     } else if (topic.includes(TwilioTopics.GetTokenResult)) {
//       handleGetTokenResult(payload);
//     } else if (topic.includes(MessageTopics.ConnectionBDS)) {
//       handleConnectionResult(payload);
//     } else if (topic.includes(PageTopics.SearchInPageResult)) {
//       handleSearchInPageResult(payload);
//     } else if (topic.includes(PageTopics.SearchInPageResult)) {
//       handleSearchInPageResult(payload);
//     } else if (topic.includes(PageTopics.CreatePageResult)) {
//       handleCreatePageResult({ subscribeToEvent, publishToEvent }, payload);
//     } else if (topic.includes(PageTopics.UpdatePageResult)) {
//       handleUpdatePageResult({ subscribeToEvent, publishToEvent }, payload);
//     } else if (topic.includes(MessageTopics.FocusMessage)) {
//       handleMessageFocus(payload);
//     } else if (topic.includes(UserSearchTopics.FindUsersToPage)) {
//       handleFindUsersToPage(payload);
//     } else if (topic.includes(UserSearchTopics.AggregateBds)) {

//       const pageRequestId = requestIds.page;
//       // localStorage.getItem("pageRequestId");
//       const userRequestId = requestIds.user;
//       // localStorage.getItem("userRequestId");

//       console.log('test page3 id', JSON.parse(payload.message))
//       if (pageRequestId === JSON.parse(payload.message)?.id) {
//         handlePageResults(JSON.parse(payload.message).response.data);
//       }
//       else if(userRequestId === JSON.parse(payload.message)?.id){
//         handleSearchBds(payload);
//       }

//     } else if (topic.includes(UserSearchTopics.SearchBds)) {
//       handleUserBds(payload);
//     }
//     if (topic.includes(PageTopics.GetProjectsResult)) {
//       getProjectList(payload);
//     }
//     if (topic.includes(PageTopics.GetAdminRolesResult)) {
//       getAdminRolesList(payload);
//     }
//     else if(topic.includes('iot-service/append')){
//       console.log('handle iot request here')
//       handleVideoIotAppend(payload)
//     }
//     else if(topic.includes('getLastIndex/reply')){
//       console.log('handle last index here', payload);
//       handleGetLastIndex(payload);
//     }
// else if(topic.includes('focusPage')){
//   handlePageFocus(payload)
// }
//   };

//   return {
//     socketClient,
//     socketConnect,
//     socketSubscribeToEvent: subscribeToEvent,
//     socketUnSubscribeToEvent: unSubscribeToEvent,
//     socketPublishToEvent: publishToEvent,
//     publishToEventUser,
//     publishToEventServiceIdUser,
//     subscribeToEventUser
//   };
// };

import { useState, useEffect, useRef } from "react";
import {
  SocketTopics,
  PageTopics,
  MapTopics,
  MessageTopics,
  TwilioTopics,
  CLBSTopics,
  UserSearchTopics,
  IotTopics,
  UserTopics,
} from "../constants/enums";
import useSocketActions from "./socketActions";
import { useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import mqtt from "mqtt";
import { generateUUID } from "utils/appUtil";

export default () => {
  const [socketClient, setSocketClient] = useState<any>();
  const { requestIds } = useSelector((state: RootState) => state.dashboard);
  const [connectedClient, setConnectedClient] = useState<any>();
  const callbacks = useRef<any>({});

  const {
    handlePageResults,
    handleFocusMap,
    handleTextMessage,
    handlePageTyping,
    handleVideoJoinNotification,
    handleVideoEndedNotification,
    handleSaveVideoNotification,
    handleRecordingMediaResult,
    handleUser,
    handleSearchMessageResult,
    handleGetPlaces,
    handleGetTokenResult,
    handleConnectionResult,
    handleSearchInPageResult,
    handleIotAppend,
    handleCreatePageResult,
    handleMessageFocus,
    handleFindUsersToPage,
    handleSearchBds,
    handleUserBds,
    handleUpdatePageResult,
    handleVideoIotAppend,
    getProjectList,
    getAdminRolesList,
    handleGetLastIndex,
    handlePageFocus,
  } = useSocketActions();

  const socketConnect = () => {
    setSocketClient(
      mqtt.connect(process.env.REACT_APP_BASE_WS_URL, {
        clientId: generateUUID(),
        username: "live",
        password: "beamL1ve",
      })
    );
  };

  useEffect(() => {
    return () => {
      if (socketClient) {
        socketClient.end(undefined, undefined, () => {
          console.log("Disconnected");
        });
      }
    };
  }, []);

  useEffect(() => {
    if (socketClient) {
      socketClient.on("connect", () => {
        console.log("Connected");
        setConnectedClient(socketClient);
      });
      socketClient.on("error", (err) => {
        console.error("Connection error: ", err);
        socketClient.end();
      });
      socketClient.on("reconnect", () => {
        console.log("Reconnecting");
      });
      socketClient.on("disconnect", () => {
        console.log("Disconnecting");
      });
      socketClient.on("message", socketMessageReceivedListener);
    }
  }, [socketClient]);

  const publishToEvent = (
    event: SocketTopics,
    topic: string,
    data: IPublishWrapRequest | IPublishRequest,
    callback: any = () => {}
  ) => {
    if (socketClient) {
      socketClient.publish(topic, JSON.stringify(data), { qos: 1 }, (error) => {
        if (error) {
          callback({ status: false });
        } else {
          callback({ status: true });
        }
      });
    }
  };

  const subscribeToEvent = (
    event: SocketTopics,
    topic: string,
    callback: any = () => {}
  ) => {
    if (socketClient) {

      console.log('subscribe topic', topic);

      socketClient.subscribe(topic, { qos: 1 }, (error) => {
        if (error) {
          console.log("Subscribe to topics error", error);
          return;
        }
        callbacks.current[topic] = callback;
      });
    }
  };

  const unSubscribeToEvent = (
    event: SocketTopics,
    topic: string,
    callback: any = () => {}
  ) => {
    if (socketClient) {
      socketClient.unsubscribe(topic, (error) => {
        if (error) {
          console.log("unSubsribed to topics error", error);
          return;
        }
      });
    }
  };

  const publishToEventUser = (
    event: SocketTopics,
    topic: string,
    data: IPublishRequest,
    subscribePath: string,
    callback: any = () => {}
  ) => {};
  const publishToEventServiceIdUser = (
    event: SocketTopics,
    topic: string,
    data: IPublishRequest,
    subscribePath: string,
    serviceId: string,
    callback: any = () => {}
  ) => {};
  const subscribeToEventUser = (
    event: SocketTopics,
    topic: string,
    callback: any = () => {}
  ) => {};

  const socketMessageReceivedListener = (topic: string, message: any) => {
    
    const payload = { topic, message: message.toString() };

    console.log('message rrsponse', payload)


    if (callbacks?.current?.[topic]) {
      callbacks?.current?.[topic](payload);
    }
    if (topic.includes(MapTopics.FocusMap)) {
      handleFocusMap(JSON.parse(payload.message));
    } else if (topic.includes(MapTopics.IotAppend)) {
      handleIotAppend(payload);
    } else if (topic.includes(MessageTopics.CreateMessageResult)) {
      handleTextMessage({ subscribeToEvent, publishToEvent }, payload);
    } else if (topic.includes(PageTopics.PageTyping)) {
      handlePageTyping(payload);
    } else if (topic.includes(TwilioTopics.VideoJoin)) {
      handleVideoJoinNotification(JSON.parse(payload.message).data);
    } else if (topic.includes(TwilioTopics.VideoEnd)) {
      handleVideoEndedNotification(JSON.parse(payload.message).data);
    } else if (topic.includes(TwilioTopics.SaveRecording)) {
      handleSaveVideoNotification(JSON.parse(payload.message).data);
    } else if (topic.includes(TwilioTopics.RecordingMediaResult)) {
      handleRecordingMediaResult(payload);
    } else if (topic.includes(PageTopics.FocusPage)) {
      handlePageFocus(payload);
    } else if (topic.includes(UserTopics.User)) {
      handleUser({ subscribeToEvent, publishToEvent }, topic, payload);
    } else if (topic.includes(MessageTopics.SearchMessageResult)) {
      handleSearchMessageResult(payload);
    } else if (topic.includes(CLBSTopics.GetPlaces)) {
      handleGetPlaces(payload);
    } else if (topic.includes(TwilioTopics.GetTokenResult)) {
      handleGetTokenResult(payload);
    } else if (topic.includes(MessageTopics.ConnectionBDS)) {
      handleConnectionResult(payload);
    } else if (topic.includes(PageTopics.SearchInPageResult)) {
      handleSearchInPageResult(payload);
    } else if (topic.includes(PageTopics.SearchInPageResult)) {
      handleSearchInPageResult(payload);
    } else if (topic.includes(PageTopics.CreatePageResult)) {
      handleCreatePageResult({ subscribeToEvent, publishToEvent }, payload);
    } else if (topic.includes(PageTopics.UpdatePageResult)) {
      handleUpdatePageResult({ subscribeToEvent, publishToEvent }, payload);
    } else if (topic.includes(MessageTopics.FocusMessage)) {
      handleMessageFocus(payload);
    } else if (topic.includes(UserSearchTopics.FindUsersToPage)) {
      handleFindUsersToPage(payload);
    } else if (topic.includes(UserSearchTopics.AggregateBds)) {
      const pageRequestId = requestIds.page;
      const userRequestId = requestIds.user;
      const messageRequestId = requestIds.message;
      if (pageRequestId === JSON.parse(payload.message)?.id) {
        handlePageResults(JSON.parse(payload.message).response.data);
      } else if (userRequestId === JSON.parse(payload.message)?.id) {
        handleSearchBds(payload);
      }
      else if (messageRequestId === JSON.parse(payload.message)?.id) {
        console.log('handle message payload', payload)
        handleSearchMessageResult(payload);
      }
    } else if (topic.includes(UserSearchTopics.SearchBds)) {
      handleUserBds(payload);
    } else if (topic.includes(PageTopics.GetProjectsResult)) {
      getProjectList(payload);
    } else if (topic.includes(PageTopics.GetAdminRolesResult)) {
      getAdminRolesList(payload);
    } else if (topic.includes(IotTopics.Append)) {
      handleVideoIotAppend(payload);
    } else if (topic.includes(IotTopics.GetLastIndex)) {
      handleGetLastIndex(payload);
    }
  };

  return {
    socketClient: connectedClient,
    socketConnect,
    socketSubscribeToEvent: subscribeToEvent,
    socketUnSubscribeToEvent: unSubscribeToEvent,
    socketPublishToEvent: publishToEvent,
    publishToEventUser,
    publishToEventServiceIdUser,
    subscribeToEventUser,
  };
};
